import AlarmsPage from "../Pages/AlarmsPage/AlarmsPage";
import ClinicalRecordPage from "../Pages/ClinicalRecordPage/ClinicalRecordPage";
import ConfigurationPage from "../Pages/ConfigurationPage/ConfigurationPage";
import DomoticaPage from "../Pages/DomoticaPage/DomoticaPage";
import LandingPage from "../Pages/LandingPage/LandingPage";
import LoginPage from "../Pages/LoginPage/LoginPage";
import LogoutPage from "../Pages/LogoutPage/LogoutPage";
import MonitoringPage from "../Pages/MonitoringPage/MonitoringPage";
import NotFoundPage from "../Pages/NotFoundPage/NotFoundPage";
import OptionsPage from "../Pages/OptionsPage/OptionsPage";
import ResetPasswordPage from "../Pages/ResetPasswordPage/ResetPasswordPage";
import SetupPage from "../Pages/SetupPage/SetupPage";
import StatisticPage from "../Pages/StatisticPage/StatisticPage";
import { AppRoutes } from "./AppRoutes";

export interface IAppRoutesMapItem {
  path: string;
  element: JSX.Element;
  requiresLogin: boolean;
  requiresRoles: string[];
}

export const AppRoutesMap: IAppRoutesMapItem[] = [
  {
    path: "/", // default
    element: <LoginPage />,
    requiresLogin: false,
    requiresRoles: [],
  },
  {
    path: AppRoutes.APP_LOGOUT_PAGE,
    element: <LogoutPage />,
    requiresLogin: false,
    requiresRoles: [],
  },
  {
    path: AppRoutes.APP_LOGIN_PAGE,
    element: <LoginPage />,
    requiresLogin: false,
    requiresRoles: [],
  },
  {
    path: AppRoutes.APP_OPTIONS_PAGE,
    element: <OptionsPage />,
    requiresLogin: true,
    requiresRoles: ["operator", "superOperator", "superAdmin", "installer"],
  },
  {
    path: AppRoutes.APP_LANDING_PAGE,
    element: <LandingPage />,
    requiresLogin: true,
    requiresRoles: ["operator", "superOperator", "superAdmin", "installer"],
  },
  {
    path: AppRoutes.APP_DOMOTICA_PAGE,
    element: <DomoticaPage />,
    requiresLogin: true,
    requiresRoles: ["operator", "superOperator", "superAdmin", "installer"],
  },
  /*{
    path: AppRoutes.APP_MONITORING_PAGE,
    element: <MonitoringPage />,
    requiresLogin: true,
    requiresRoles: ["operator", "superOperator", "superAdmin", "installer"],
  },*/
  {
    path: AppRoutes.APP_STATISTIC_PAGE,
    element: <StatisticPage />,
    requiresLogin: true,
    requiresRoles: ["superOperator", "superAdmin", "installer"],
  },
  {
    path: AppRoutes.APP_SETUP_PAGE,
    element: <SetupPage />,
    requiresLogin: true,
    requiresRoles: ["superAdmin", "installer"],
  },
  {
    path: AppRoutes.APP_RESET_PASSWORD_PAGE,
    element: <ResetPasswordPage />,
    requiresLogin: true,
    requiresRoles: ["operator", "superOperator", "superAdmin", "installer"],
  },
  {
    path: AppRoutes.APP_CLINICAL_RECORD_PAGE,
    element: <ClinicalRecordPage />,
    requiresLogin: true,
    requiresRoles: ["operator", "superOperator", "superAdmin", "installer"],
  },
  {
    path: AppRoutes.APP_CONFIGURE_PAGE,
    element: <ConfigurationPage />,
    requiresLogin: true,
    requiresRoles: ["operator", "superOperator", "superAdmin", "installer"],
  },
  {
    path: AppRoutes.APP_ALARMS_PAGE,
    element: <AlarmsPage />,
    requiresLogin: true,
    requiresRoles: ["superOperator", "superAdmin", "installer"],
  },
  {
    path: AppRoutes.APP_NOT_FOUND_PAGE,
    element: <NotFoundPage />,
    requiresLogin: false,
    requiresRoles: [],
  },
];
